import React from 'react';
import { TextField, TextFieldProps, styled } from '@mui/material';

const InputField = styled((props: TextFieldProps) => (
    <TextField variant='filled' {...props} />
))(({ theme }) => ({
    backgroundColor: '#FEFBFF',
    '& .MuiFilledInput-root': {
        fontWeight: 500,
        backgroundColor: '#FEFBFF',
        '& fieldset': {
            borderColor: '#E0E0E0',
        },
        '&:hover fieldset': {
            borderColor: '#2D4677',
        },
        '&.Mui-focused fieldset': {
            borderColor: '#2D4677',
            borderWidth: 2.5,
        },
    },
    '& .MuiFilledInput-root.Mui-focused .MuiFilledInput-underline:before': {
        borderBottomColor: '#2D4677',
    },
    '& .MuiInputLabel-root': {
        color: '#6B7280',
        fontSize: 13,
    },
    '& .Mui-focused .MuiInputLabel-root': {
        color: '#2D4677',
    },
    // Override disabled styles to maintain normal appearance
    '& .MuiFilledInput-root.Mui-disabled': {
        backgroundColor: '#FEFBFF',
        '& fieldset': {
            borderColor: '#E0E0E0',
        },
        '& input': {
            color: '#000000',
            WebkitTextFillColor: '#000000',
        },
        '& textarea': {
            color: '#000000',
            WebkitTextFillColor: '#000000',
        },
    },
    '& .MuiInputLabel-root.Mui-disabled': {
        color: '#6B7280',
    },
}));

export default InputField;
